export const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

// 过滤对象值为空的属性
export const filterEmptyObject = o =>
  Object.fromEntries(
    Object.keys(o)
      .filter(k => !['', undefined, null].includes(o[k]))
      .map(k => [k, o[k]])
  )

export const calcTime = (timeTemp, type) => {
  if (!timeTemp) return '-/-/- -:-:-'

  let time = new Date(timeTemp * 1)
  let year = time.getFullYear()
  let month = (time.getMonth() + 1).toString().padStart(2, '0')
  let day = time.getDate().toString().padStart(2, '0')
  let hour = time.getHours().toString().padStart(2, '0')
  let min = time.getMinutes().toString().padStart(2, '0')
  let sec = time.getSeconds().toString().padStart(2, '0')
  if (!type) return `${year}-${month}-${day} ${hour}:${min}:${sec}`
  try {
    return [...type]
      .map(i => {
        switch (i) {
          case 'y':
            return year
          case 'M':
            return month
          case 'd':
            return day
          case 'h':
            return hour
          case 'm':
            return min
          case 's':
            return sec
          default:
            return i
        }
      })
      .join('')
  } catch (err) {
    return `${year}:${month}:${day} ${hour}:${min}:${sec}`
  }
}

export const copyText = text => navigator.clipboard.writeText(text)

export const baseImgUrl = process.env.VUE_APP_BASE_IMG_URL

export const formatImgFullPath = path => {
  if (!path) return ''
  if (path.startsWith('http')) return path
  return baseImgUrl + path
}
